<template>
  <div id="impresion-sub-tab">
    <v-layout align-center justify-center>
      <v-flex lg12>
        <template>
          <v-tabs v-model="active_tab">
            <v-tabs-slider :key="index" color="blue"></v-tabs-slider>
            <v-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="selected(tab)"
              >{{ tab }}</v-tab
            >
            <v-tabs-items>
              <!-- TAB DE ACUERDO -->
              <v-card flat v-if="tabSelected == 'Acuerdo'">
                <acuerdo-impresion-tab
                  :show="true"
                  :tipeView="'consulta'"
                  :contratoId="contratoId"
                ></acuerdo-impresion-tab>
              </v-card>
              <!-- TAB DE PROGRESO -->
              <v-card flat v-if="tabSelected == 'Progreso'">
                <progreso-diario-tab
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></progreso-diario-tab>
              </v-card>
              <!-- TAB DE EVOLUCION -->
              <v-card flat v-if="tabSelected == 'Evolucion'">
                <progreso-evolucion-tab
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></progreso-evolucion-tab>
              </v-card>
              <!-- TAB DE CONTINGENCIA -->
              <v-card flat v-if="tabSelected == 'Contingencia'">
                <contingencia-impresion-tab
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></contingencia-impresion-tab>
              </v-card>
              <!-- TAB DE CALIDAD -->
              <v-card flat v-if="tabSelected == 'Calidad'">
                <calidad-impresion-tab
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></calidad-impresion-tab>
              </v-card>
            </v-tabs-items>
          </v-tabs>
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import AcuerdoImpresionTab from "@/modules/impresion/views/acuerdo/AcuerdoImpresionTab.vue";
import ProgresoDiarioTab from "@/modules/impresion/views/progreso/ProgresoImpresionTab.vue";
import ProgresoEvolucionTab from "@/modules/impresion/views/evolucion/ProgresoEvolucionTab.vue";
import ContingenciaImpresionTab from "@/modules/impresion/views/contingencia/ContingenciaImpresionTab.vue";
import CalidadImpresionTab from "@/modules/impresion/views/calidad/CalidadImpresionTab.vue";

export default {
  name: "impresion-sub-tab",

  components: {
    AcuerdoImpresionTab,
    ProgresoDiarioTab,
    ProgresoEvolucionTab,
    ContingenciaImpresionTab,
    CalidadImpresionTab,
  },
  props: {},
  data: () => ({
    text: "En construccion",
    proveedor: {},
    tabs: ["Acuerdo", "Progreso", "Evolucion", "Contingencia", "Calidad"],
    contratoId: "",
    tabSelected: "",
    activeTab: "",
    index: "",
    active_tab: "",
  }),
  mounted() {},
  created() {
    if (
      !this.$route.params.contratoId ||
      this.$route.params.contratoId == null ||
      this.$route.params.contratoId == ""
    ) {
      this.contratoId = this.$store.getters.contratoStored;
    } else {
      this.contratoId = this.$route.params.contratoId;
    }
    this.loadSelected();
    this.active_tab = this.tabs.indexOf(
      this.$store.getters.subTabSelectedStored
    );
  },
  methods: {
    loadSelected() {
      if (this.$store.getters.subTabSelectedStored == "Evolucion") {
        let diarioTab = "Diario";
        this.$store.commit("evolucion_tab_state", diarioTab);
      }
      this.tabSelected = this.$store.getters.subTabSelectedStored;
    },
    selected(tab) {
      if (tab == "Evolucion") {
        let diarioTab = "Diario";
        this.$store.commit("evolucion_tab_state", diarioTab);
      }
      this.$store.commit("sub_tab_state", tab);
      this.tabSelected = tab;
    },
  },
};
</script>
